import { render, staticRenderFns } from "./Push.vue?vue&type=template&id=082c52fe&scoped=true"
import script from "./Push.vue?vue&type=script&lang=js"
export * from "./Push.vue?vue&type=script&lang=js"
import style0 from "./Push.vue?vue&type=style&index=0&id=082c52fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c52fe",
  null
  
)

export default component.exports